import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "status", "branchField"]
  static values = { url: String, current: String }

  connect() {
    this.fetchRepos()
  }

  async fetchRepos() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "application/json" }
      })
      const data = await response.json()

      if (data.error) {
        this.statusTarget.textContent = data.error
        return
      }

      const select = this.selectTarget
      // Clear existing options except the placeholder
      select.innerHTML = '<option value="">Select a repository...</option>'

      data.repos.forEach(repo => {
        const option = document.createElement("option")
        option.value = repo.html_url
        option.textContent = repo.full_name + (repo.private ? " (private)" : "")
        option.dataset.defaultBranch = repo.default_branch
        if (repo.html_url === this.currentValue) {
          option.selected = true
        }
        select.appendChild(option)
      })

      this.statusTarget.textContent = `${data.repos.length} repositories available`
    } catch (e) {
      this.statusTarget.textContent = "Failed to load repositories"
    }
  }

  repoChanged() {
    const selected = this.selectTarget.selectedOptions[0]
    if (selected && selected.dataset.defaultBranch && this.hasBranchFieldTarget) {
      const branchField = this.branchFieldTarget
      if (!branchField.value || branchField.value === "main" || branchField.value === "master") {
        branchField.value = selected.dataset.defaultBranch
      }
    }
  }
}
